export default __webpack_public_path__ + "static/media/RecentIcon.cac3c244.svg";